import { Grid, GridProps, Flex, Checkbox, Text } from '@cad-arc';
import { Option } from '../../forms/option';

export function CheckboxMultiselect<T extends string | number>({
    options,
    value,
    onChange,
    disabledOptions = [],
    columns = 2,
    w,
    globalComplementaryLabel,
    isScrollable,
    isReadOnly,
}: {
    options: Option<T>[];
    value: Array<string | number>;
    onChange: (value: Array<string | number>) => void;
    disabledOptions?: Array<string | number>;
    columns?: number;
    w?: GridProps['w'];
    globalComplementaryLabel?: string;
    isScrollable?: boolean;
    isReadOnly?: boolean;
}): React.ReactElement {
    return (
        <Grid
            templateColumns={`repeat(${columns}, 1fr)`}
            gap={10}
            w={w ?? '100%'}
            paddingTop="10"
            paddingLeft="5"
            style={{ ...(isScrollable ? { overflowY: 'auto' } : {}) }}
        >
            {options.map((option) => (
                <Checkbox
                    isReadOnly={isReadOnly}
                    key={option.value}
                    value={option.value}
                    isChecked={value.some((v) => v === option.value)}
                    isDisabled={disabledOptions.includes(option.value)}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                        e?.target?.checked
                            ? onChange(
                                  value.includes(option.value) ? value : [...value, option.value]
                              )
                            : onChange(value.filter((v) => v !== option.value))
                    }
                    data-testid={`${option.label}`}
                >
                    {globalComplementaryLabel ? (
                        <Flex gap="5px">
                            <Text>{option.label}</Text>
                            <Text as="i" color="tertiary">
                                {globalComplementaryLabel}
                            </Text>
                        </Flex>
                    ) : (
                        <Text>{option.label}</Text>
                    )}
                </Checkbox>
            ))}
        </Grid>
    );
}
